import { Link } from "react-router-dom";
import { SITE, NAV_LINKS } from "@/lib/site";
import LogoMark from "@/components/site/LogoMark";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-ink text-bone/80 pt-20 pb-10"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid grid-cols-12 gap-6 md:gap-12 mb-16">
                    <div className="col-span-12 md:col-span-6">
                        <div className="flex items-center gap-4">
                            <LogoMark
                                size="w-14 h-14"
                                testId="footer-logo-img"
                            />
                            <span className="font-serif text-3xl md:text-4xl text-bone tracking-tight">
                                {SITE.name}
                            </span>
                        </div>
                        <p className="mt-6 max-w-md text-bone/65 leading-relaxed">
                            An emerging platform exploring Indigenous-led
                            approaches to land management, restoration, food
                            security, native seed systems, climate resilience
                            and community development.
                        </p>
                        <p className="mt-3 italic text-bone/55 text-sm">
                            Healthy Country. Strong communities. Local
                            decision-making. Inseparable.
                        </p>
                    </div>

                    <div className="col-span-6 md:col-span-3">
                        <span className="eyebrow text-bone/50">Sections</span>
                        <ul className="mt-4 space-y-2">
                            {NAV_LINKS.map((l) => (
                                <li key={l.href}>
                                    <Link
                                        to={l.href}
                                        className="text-bone/80 hover:text-ochre transition-colors text-[15px]"
                                    >
                                        {l.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="col-span-6 md:col-span-3">
                        <span className="eyebrow text-bone/50">Contact</span>
                        <ul className="mt-4 space-y-2 text-[15px]">
                            <li>
                                <a
                                    href={`mailto:${SITE.email}`}
                                    data-testid="footer-mailto"
                                    className="text-bone/80 hover:text-ochre transition-colors editorial-link"
                                >
                                    {SITE.email}
                                </a>
                            </li>
                            <li className="text-bone/60">{SITE.domain}</li>
                        </ul>
                    </div>
                </div>

                <div className="pt-8 border-t border-bone/15">
                    <p
                        data-testid="acknowledgement"
                        className="font-serif italic text-base md:text-lg text-bone/75 max-w-3xl"
                    >
                        We acknowledge the Traditional Owners of the lands and
                        waters across this continent, and pay respect to Elders
                        past, present and emerging — and to the knowledge, law
                        and practice that continues to care for Country.
                    </p>

                    <div className="mt-10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-bone/50">
                        <span>
                            © {new Date().getFullYear()} {SITE.name}. All rights
                            reserved.
                        </span>
                        <span className="tracking-[0.22em] uppercase">
                            Land. Sea. Water. Generations.
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
